<template>
    <glass-panel
        radius="md"
        class="filter-bar pa-4"
    >
        <div
            v-if="$slots.leading"
            class="filter-bar__leading"
        >
            <slot name="leading" />
        </div>

        <div class="filter-bar__filters">
            <slot />
        </div>

        <div
            v-if="$slots.trailing"
            class="filter-bar__trailing"
        >
            <slot name="trailing" />
        </div>
    </glass-panel>
</template>

<script>
export default {
    name: 'FilterBar',
}
</script>

<style scoped>
.filter-bar {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 12px;
}

.filter-bar__leading {
    display: flex;
    align-items: center;
    gap: 8px;
    flex-shrink: 0;
}

.filter-bar__filters {
    flex: 1;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 12px;
    min-width: 0;
    justify-content: flex-end;
}

.filter-bar__filters > * {
    min-width: 180px;
    flex: 1 1 200px;
    max-width: 280px;
}

.filter-bar__trailing {
    display: flex;
    align-items: center;
    gap: 8px;
    flex-shrink: 0;
}

@media (max-width: 600px) {
    .filter-bar__filters > * {
        max-width: none;
    }
}
</style>
